import { createActionTypes } from "@helpers/redux-helpers";

export const verificationActionTypes = createActionTypes("verification");

export const resendVerificationLinkActionTypes = createActionTypes(
  "verification/resend",
);

export const verificationPasswordCodeActionTypes = createActionTypes(
  "verification/password/code",
);

export const confirmEmailChangeActionTypes =
  createActionTypes("verification/email");
